import logo from './logo.svg';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './pages/home';
import Carousel from './pages/test';

function App() {
  return (
    <div className="App">
      <BrowserRouter >
      <Routes>
        <Route path='/' element={<Home/>} />
        <Route path='/Carousel' element={<Carousel/>} />
      </Routes>
      </BrowserRouter >
     
    </div>
  );
}

export default App;
